__turbopack_context__.v({
  "ctaGroup": "CtaLinks-module-scss-module__Mh-SSq__ctaGroup",
  "ctaLink": "CtaLinks-module-scss-module__Mh-SSq__ctaLink",
  "ctaUnderline": "CtaLinks-module-scss-module__Mh-SSq__ctaUnderline",
});
